import { useMutation } from '@tanstack/react-query';
import { CreateChatRequest } from '@/types/request/CreateChatRequest';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { queryClient } from '@/main.tsx';
import { Chat } from '@/models/Chat';
import BackendClient from '@/api/backendClient.ts';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const useChatCreate = () => {
  const mutationFn = async (request: CreateChatRequest) => {
    return createChat(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['chats'] });
    },
  });
};

export default useChatCreate;

async function createChat(request: CreateChatRequest): Promise<Chat> {
  try {
    const response = await BackendClient.post<BackendSuccessResponse<Chat>>('/api/chat/create', request);

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while creating chat.');
  }
}
